<template>
  <div style="height: 100%;">
      <el-table
    :data="tableData"
    height="100%"
    :border="true"
    :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    ref="multipleTable"
    tooltip-effect="dark"
    style="width: 100%"
  >
    <el-table-column type="index" width="80" align="center" label="序号">
    </el-table-column>

    <el-table-column
      prop="supplier_name"
      align="center"
      label="供应商名称"
      min-width="200"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
      
   
        <span v-if="scope.row.supplier">
            <span>{{ scope.row.supplier.title || "-" }}</span>
          -{{ scope.row.supplier.id || "-" }}
          【{{ scope.row.supplier.mobile || "-" }}】
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="supplier_name"
      align="center"
      label="扣款时名称"
      min-width="200"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span>{{ scope.row.supplier_name || "-" }}</span>
      </template>
    </el-table-column>

    <el-table-column
      prop="logistic_business_name"
      align="center"
      label="集配中心"
      min-width="100"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span>{{ scope.row.logistic_business_name || "-" }}</span>
      </template>
    </el-table-column>

    <el-table-column
      prop="create_time"
      align="center"
      label="添加时间"
      min-width="100"
    >
    </el-table-column>

    <el-table-column
      prop="operate_name"
      align="center"
      label="添加人"
      min-width="100"
    >
      <template slot-scope="scope">
        {{ scope.row.operate_name || "-" }}
      </template>
    </el-table-column>

    <el-table-column
      prop="deduction_amt"
      align="center"
      label="扣款金额"
      min-width="100"
    >
    </el-table-column>

    <el-table-column
      prop="check_operate_name"
      align="center"
      label="审核人"
      min-width="100"
    >
      <template slot-scope="scope">
        {{ scope.row.check_operate_name || "-" }}
      </template>
    </el-table-column>

    <el-table-column
      prop="deduction_type_txt"
      align="center"
      label="扣款类型"
      min-width="100"
    >
    </el-table-column>

    <el-table-column
      prop="as_no"
      align="center"
      label="售后单号"
      min-width="100"
    >
      <template slot-scope="scope">
        {{ scope.row.as_no || "-" }}
      </template>
    </el-table-column>
<el-table-column
      prop="order_no"
      align="center"
      label="订单号"
      min-width="100"
    >
    <template slot-scope="scope">
        {{ scope.row?.order_no || "-" }}
      </template>
    </el-table-column>
    <el-table-column
      prop="title"
      align="center"
      label="商品名称"
      min-width="100"
    > <template slot-scope="scope">
        {{ scope.row?.title || "-" }}
      </template>
    </el-table-column>
    <el-table-column
      prop="trade_no"
      align="center"
      label="退款流水号"
      min-width="100"
    >
      <template slot-scope="scope">
        {{ scope.row?.order_refund?.trade_no || "-" }}
      </template>
    </el-table-column>

    <el-table-column
      prop="deduction_state_txt"
      align="center"
      label="扣款状态"
      min-width="100"
    >
    </el-table-column>

    <el-table-column
      prop="check_state_txt"
      align="center"
      label="审核状态"
      min-width="100"
    >
    </el-table-column>

    <el-table-column
      prop="check_time"
      align="center"
      label="扣款时间"
      min-width="100"
    >
    </el-table-column>

    <el-table-column label="操作" min-width="120" align="center">
      <template slot-scope="scope">
        <el-button
          @click="onHandleEdit(scope.row, 'view')"
          type="text"
          size="small"
          >查看</el-button
        >
        <!-- 有审核权限，且未审核 start -->
        <el-button
          v-if="isAudit && scope.row.check_state === CHECK_STATUS.NO.value"
          @click="onHandleEdit(scope.row, 'audit')"
          type="text"
          size="small"
          >审核</el-button
        >
        <!-- 有审核权限，且未审核 end -->

        <!-- 有审核权限，且未审核 start -->
        <el-button
          v-if="isAudit && scope.row.check_state === CHECK_STATUS.NO.value"
          @click="onHandleEdit(scope.row, 'delete')"
          type="text"
          size="small"
          >作废</el-button
        >
        <!-- 有审核权限，且未审核 end -->
      </template>
    </el-table-column>
  </el-table>
    <el-dialog
  title="作废"
  v-if="centerDialogVisible"
  :visible.sync="centerDialogVisible"
  width="40%"
  center>
  <div>供应商：{{infodata.supplier_name}}[{{ infodata.supplier.mobile }}]</div>
  <div>扣款类型：{{infodata.deduction_type_txt}}</div>
  <div>扣款金额： {{infodata.deduction_amt}}元</div>
  <div>备注：</div>
  <el-input
  type="textarea"
  :rows="2"
  :maxlength="200"
  :show-word-limit="true"
  placeholder="请输入内容"
  v-model="textarea">
</el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="ajaxPostSupplierDeductionDel">确 定</el-button>
  </span>
</el-dialog>
  </div>

</template>

<script>
import { CHECK_STATUS } from "../../utils/enum/index";
import {
  postSupplierDeductionAudit,
  postSupplierDeductionDel,
} from "@/api/general/operation-center/index";

export default {
  name: "TableList",
  props: {
    /**
     * 是否有审核权限
     */
    isAudit: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      CHECK_STATUS,
      centerDialogVisible:false,
      textarea:'',
      id:'',
      infodata:''
    };
  },
  methods: {
    /**
     * 操作了数据
     */
    onHandleEdit(row, type) {
      // 查看
      if (type === "view") {
        const params = {
          type,
          row,
        };
        this.$emit("on-edit", params);
      }
      const params = {
        id: row.id,
      };
      this.id=row.id;
      // 审核
      if (type === "audit") {
        this.$confirm("审核后立即生效，确认操作？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          customClass: "jn-confirm-message-style",
          iconClass: "el-icon-warning",
        }).then(() => {
          this.ajaxPostSupplierDeductionAudit(params);
        });
      }
      // 作废
      if (type === "delete") {
        this.infodata=row;
        this.id=row.id;
        this.centerDialogVisible=true;
        // this.$confirm("确定作废这条数据？", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   center: true,
        //   customClass: "jn-confirm-message-style",
        //   iconClass: "el-icon-warning",
        // }).then(() => {
        //   this.ajaxPostSupplierDeductionDel(params);
        // });
      }
    },
    /**
     * 审核
     */
    async ajaxPostSupplierDeductionAudit(params) {
      try {
        await postSupplierDeductionAudit(params);
        this.$message.success("操作成功！");
        this.$emit("on-change");
      } catch (error) {
        console.log("ajax postSupplierDeductionAudit err", error);
      }
    },
    /**
     * 作废
     */
    async ajaxPostSupplierDeductionDel(params) {
      if(!this.textarea){
         this.$message.error("请输入备注！");
         return;
      }
      try {
        await postSupplierDeductionDel({
          id:this.id,
          process_remark:this.textarea
        });
        this.centerDialogVisible=false;
        this.$message.success("操作成功！");
        this.$emit("on-change");
      } catch (error) {
        console.log("ajax postSupplierDeductionDel err", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
